export const pad2 = (value: number): string => (value < 10 ? `0${value}` : value.toString());

export const pad3 = (value: number): string => {
  if (value < 10) {
    return `00${value}`;
  } if (value < 100) {
    return `0${value}`;
  }
  return value.toString();
};

export const pad4 = (value: number): string => {
  if (value < 10) {
    return `000${value}`;
  } if (value < 100) {
    return `00${value}`;
  } if (value < 1000) {
    return `0${value}`;
  }
  return value.toString();
};
